<div class="table-container">
  <div class="table-header">
    <h4 class="title">
      {{ 'module.meterReading.consumptionAndGenerationText' | translate }}
    </h4>
    <span class="fa fa-info-circle" aria-hidden="true" (click)="showMeterDataInfoModal()"></span>
    <app-filter-options
      #filterOptionsComponent
      class="filter"
      [isInMeterWizard]="isInMeterWizard"
      (filterEnergyType)="filterUsingEnergyType($event)"
      (filterMeterType)="filterUsingMeterType($event)"
      (filterMarketOperator)="filterUsingMarketOperator($event)"
    ></app-filter-options>
    <input
      #search
      class="search-text"
      [(ngModel)]="searchParam"
      placeholder="{{ 'module.meterReading.freeTextSearchablePlaceholder' | translate }}"
      (input)="searchValue$.next($event.target.value)"
      (keydown)="onSearchKeydown($event)"
    />
    <button class="btn btn-outline-primary btn-search" (click)="searchMeter()" [disabled]="!searchParam">
      <span class="fa fa-search" aria-hidden="true"></span>{{ 'module.meterReading.searchButtonText' | translate }}
    </button>
    <button class="btn btn-outline-primary btn-onboard" (click)="onboardElement()" *ngIf="!!authService.permissions.SENSOR_ONBOARDING && !isInMeterWizard">
      <span class="fa fa-plus-circle" aria-hidden="true"></span>{{ 'module.shared.sensorOnboardingButtonText' | translate }}
    </button>
  </div>

  <div [ngClass]="{ 'table-body': !this.isInMeterWizard, 'table-body-wizard': this.isInMeterWizard }">
    <table
      aria-describedby="meter-table"
      class="energy-data-table"
      matSort
      (matSortChange)="sortData($event)"
      matSortDisableClear
      [matSortActive]="uiSort.active"
      [matSortDirection]="uiSort.direction"
    >
      <th scope="sonarqubefix" class="sonarqubefix"></th>
      <tr class="table-row">
        <td class="table-cell -header meter-checkbox-all" *ngIf="isInMeterWizard">
          <section class="meter-check-all">
            <mat-checkbox [checked]="isAllChecked" (change)="onMeterCheckAllChange($event)" class="meter-check-all"></mat-checkbox>
          </section>
        </td>
        <td class="table-cell -header meter-type" mat-sort-header="meterTypesName">
          {{ 'module.meterReading.measuringSystemHeaderButtonText' | translate }}
        </td>
        <td class="table-cell -header energy-type" mat-sort-header="energyTypesName">
          {{ 'module.meterReading.typeHeaderButtonText' | translate }}
        </td>
        <td class="table-cell -header address" mat-sort-header="street, houseNumber, zipCode, district">
          {{ 'module.meterReading.addressHeaderButtonText' | translate }}
        </td>
        <td class="table-cell -header object" mat-sort-header="buildingTypesName">
          {{ 'module.meterReading.objectHeaderButtonText' | translate }}
        </td>
        <td *ngIf="!isInMeterWizard" class="table-cell -header notes" mat-sort-header="notes">
          {{ 'module.meterReading.notesHeaderButtonText' | translate }}
        </td>
        <td
          class="table-cell -header"
          mat-sort-header="meterNumber"
          [ngClass]="{
            'meter-number': groupedData.length <= _energyDataStore?.filter?.pageSize || _energyDataStore?.filter?.pageSize === 0 || !isInMeterWizard,
            'meter-number-overflow': groupedData.length >= 3 && _energyDataStore?.filter?.pageSize >= 0 && isInMeterWizard
          }"
        >
          {{ 'module.meterReading.meterNumberMarketLocationSensorNumberHeaderText' | translate }}
        </td>
        <td class="table-cell -header energy-guard" *ngIf="!!authService.permissions.ENERGY_GUARD && !isInMeterWizard && isMunicipalityEnergyGuardLicensed">
          {{ 'module.energyGuard.moduleName' | translate }}
        </td>
        <td class="table-cell -header graph" *ngIf="!isInMeterWizard"></td>
      </tr>
    </table>
  </div>

  <div [ngClass]="{ 'table-body': !this.isInMeterWizard, 'table-body-wizard': this.isInMeterWizard }">
    <table
      aria-describedby="energy-data-table"
      class="energy-data-table"
      matSort
      (matSortChange)="sortData($event)"
      matSortDisableClear
      [matSortActive]="uiSort.active"
      [matSortDirection]="uiSort.direction"
    >
      <th scope="sonarqubefix" class="sonarqubefix"></th>
      <ng-container *ngIf="isInMeterWizard; else elseTemplate">
        <tr *ngFor="let dataArray of groupedData">
          <td colspan="7">
            <app-meter-wizard-collapsible-row
              [hasDeviceEUI]="hasDeviceEUI"
              [data]="dataArray"
              [isChecked]="isInCheckMeterList(dataArray)"
              [energyGuardData]="energyGuardData"
              (checkMeter$)="onCheckMeter($event)"
            ></app-meter-wizard-collapsible-row>
          </td>
        </tr>
      </ng-container>
      <ng-template #elseTemplate>
        <tr *ngFor="let dataArray of groupedData">
          <td colspan="7">
            <app-collapsible-row
              [data]="dataArray"
              [energyGuardData]="energyGuardData"
              [isMunicipalityLicensed]="isMunicipalityEnergyGuardLicensed"
            ></app-collapsible-row>
          </td>
        </tr>
      </ng-template>

      <tr>
        <td colspan="7" class="footer">
          <app-paginator
            class="paginator"
            *ngIf="maxRowCount && maxRowCount > 0 && !isFilterByBuilding && !isInMeterWizard"
            [index]="index$.value"
            [length]="maxRowCount"
            [pageSize]="pageSize"
            [resultsPerPage]="resultsPerPage"
            (page)="pageChange($event)"
          >
          </app-paginator>

          <app-notification-card
            class="app-notification-card"
            *ngIf="!overlayLoaderService.isLoading && maxRowCount === 0"
            type="info"
            text="{{ 'module.meterReading.currentlyNoDataDescriptionEnergyDataText' | translate }}"
          >
          </app-notification-card>
        </td>
      </tr>
    </table>
  </div>
</div>
